export default "__VITE_ASSET__14b88ccc__"